var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-breadcrumb"},[_c('v-btn',{staticClass:"btn-home",attrs:{"icon":"","text":"","plain":"","to":{ name: 'home' }}},[_c('svg-icon',{attrs:{"icon":"home"}})],1),_c('span',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }